import state from './docState'
import mutations from './docMutations'
import getters from './docGetters'
import actions from './docActions'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
